export default __webpack_public_path__ + "images/segment_well_done_illustration.1e27ef0ab7268187a168f7e5e3b6d1a9.svg";